import React, { PureComponent } from "react";
import PropTypes from "prop-types";

export class Checkbox extends PureComponent {
    render() {
        return (
            <div className={this.props.className}>
                <input
                    id={this.props.id}
                    onClick={this.props.onClick}
                    onChange={this.props.onChange}
                    checked={this.props.checked}
                    type="checkbox"
                    disabled={this.props.disabled}
                />
                <label htmlFor={this.props.id}>{this.props.text}</label>
            </div>
        );
    }
}

Checkbox.propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
    onClick: PropTypes.func,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    checked: PropTypes.bool
};
